<template><warehouse-operation-page kind="transfer" /></template>
<script>import WarehouseOperationPage from './WarehouseOperationPage.vue'; export default { name: 'WarehouseTransferOperation', components: { WarehouseOperationPage } }</script>
